import { DataGridPremium, type GridApi } from '@mui/x-data-grid-premium'
import { WhoWhoTypeEnum } from '@mynt/backoffice-api-spec/card-audit/models'
import { memo, useMemo, useRef } from 'react'
import { useCardAuditLog } from '../../api/react-query'
import { AUDIT_COLUMNS, type CardAuditLog } from './CardAuditHelper'

interface CustomerCardTabOverviewSingleCardDetailsAuditProps {
  customerId: string
  cardId: string
}

export const CustomerCardTabOverviewSingleCardDetailsAudit = memo(function CustomerCardTabOverviewSingleCardDetailsAudit({
  customerId,
  cardId,
}: CustomerCardTabOverviewSingleCardDetailsAuditProps) {
  // --- State & Refs (useState, useRef) ---
  const apiRef = useRef<GridApi>({} as GridApi)

  // --- Custom Hooks ---
  const { data: auditData } = useCardAuditLog(customerId, cardId)

  // --- Derived State (useMemo) ---
  const mappedData = useMemo<CardAuditLog[]>(() => {
    if (!auditData) return []

    return auditData.map((data, index) => {
      return {
        id: `${data.when}-${index}`,
        cardAuditType: data.cardAuditAction,
        values: data.values,
        when: data.when,
        who: data.who?.name ? `${data.who.name}${data.who.whoType === WhoWhoTypeEnum.BO ? ' (BackOffice)' : ''}` : '-',
        shownToCustomer: data.shownToCustomer,
      }
    })
  }, [auditData])

  // --- Effects (useEffect) ---

  // --- Event Handlers (useCallback) ---

  // --- Render ---

  return (
    <DataGridPremium
      apiRef={apiRef}
      rows={mappedData}
      columns={AUDIT_COLUMNS}
      getRowHeight={() => 'auto'}
      headerFilters
      disableColumnFilter
      headerFilterHeight={81}
      pagination
      disableRowSelectionOnClick
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
        sorting: { sortModel: [{ field: 'when', sort: 'desc' }] },
        filter: { filterModel: { items: [] } },
      }}
      pageSizeOptions={[10, 25, 50]}
      slotProps={{ toolbar: { showQuickFilter: true }, headerFilterCell: { showClearIcon: true } }}
    />
  )
})
